/**
 * Analogous to CDS's RemoteImage component.
 *
 * We are going with this implementation to minimize the coupling
 * of the app-switcher to CDS versions.
 */

import { useCallback, useState } from 'react';
import {
  RemoteImage as CDSRemoteImage,
  RemoteImageProps as CDSRemoteImageProps,
} from '@cbhq/cds-web/media';

import { useFallbackIllustrationUrl } from './hooks/useFallbackIllustration';

type RemoteImageProps = CDSRemoteImageProps & {
  source: string;
  testID?: string;
  width?: number;
  height?: number;
};

export const WIDTH = 48;
export const HEIGHT = 48;

export function RemoteImage({
  source,
  testID,
  height = HEIGHT,
  width = WIDTH,
  ...rest
}: RemoteImageProps) {
  const [finalSource, setFinalSource] = useState(source);
  const fallbackIllustration = useFallbackIllustrationUrl();

  const handleError = useCallback(() => {
    setFinalSource(fallbackIllustration);
  }, [fallbackIllustration]);
  if (source === '') {
    return null;
  }
  return (
    <CDSRemoteImage
      {...rest}
      data-testid={testID}
      source={finalSource}
      onError={handleError}
      width={width}
      height={height}
    />
  );
}
